module.exports = __webpack_public_path__ + "static/media/thumbnail.9f5b045d.jpg";